export const BREVO_KEY='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';
export const FROM_EMAIL='headit@anilbaghihospital.com';
export const FROM_NAME='Ankur IVF';
export const API_URL='https://abhhealthcare.org/api/';
